<template>
    <rkm-table
        :fields="procedimentos"
        :items="model.procedimentos"
        hide-filters
        hide-pagination
    >
        <template v-slot:cell(actions)="{ index }">
            <rkm-button
                @click="destroy(index)"
                color="danger"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-table>
</template>

<script>
export default {
    computed: {
        fields() {
            return {
                autocomplete: {
                    procedimento: this.model.searchByApelido
                        ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                        : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
                },
            }
        },
        procedimentos() {
            return [
                {
                    key: "quantidade",
                    label: "Quantidade",
                    class: "col-min"
                },
                {
                    key: "codigo",
                    label: "Código",
                    class: "col-min",
                },
                {
                    key: "nome",
                    label: "Procedimento",
                },
                {
                    key: "actions",
                    label: "Ações",
                    class: "col-min",
                },
            ]
        }
    },
    methods: {
        destroy(index) {
            this.model.procedimentos.splice(index, 1)
        }
    },
    props: {
        model: { type: Object, required: false },
    },
};
</script>
